import Waypoint from "./container";

export default Waypoint;
